export const enum PublicDashboardEndpointPath {
  Base = ``,
  Metadata = `metadata`,
}

export interface PublicDashboardMetadataPatchOptions {
  is_enabled: boolean;
}

export interface PublicDashboardMetadataApiResponse {
  is_enabled: boolean;
  last_modified_by_user_email: string;
  last_modified_datetime: string;
  project_id: number;
}

interface Dashboard {
  id: number;
  title: string;
  description: string;
  is_private: boolean;
  card_order: any;
  creator: string;
  creator_id: number;
  creator_name: string;
  creator_email: string;
  is_restricted: boolean;
  filters: any;
  time_filter: any;
}
export interface PublicDashboardListApiResponse {
  creator_email: string;
  dashboard_id: number;
  workspace_id: number;
  public_link_id: string;
  created: string;
  deleted: boolean;
  dashboard: Dashboard;
}
